import { FC, CSSProperties } from 'react';
import {
  Control,
  Controller,
  UseFormTrigger,
} from 'react-hook-form';
import { IconName, Icon } from '../Icon';
import { stringToPhone } from 'Utils/MaskUtils';
import { LabelInput } from './styles';

export interface IFieldControled {
  name: string;
  control: Control<any>;
  label: string;
  style?: CSSProperties;
  className?: string;
  icon?: IconName;
  rightIcon?: IconName;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLenght?: number;
  height?: string;
  autoFocus?: boolean;
  customMask?: boolean;
  trigger: UseFormTrigger<any>;
  onFocus?: () => void;
  onBlur?: () => void;
  onClick?: () => void;
  onChange?: (value: string) => void;
}

const FieldControled: FC<IFieldControled> = ({
  name,
  control,
  label,
  style,
  icon,
  type = 'text',
  placeholder = label,
  disabled,
  className,
  height,
  maxLenght,
  autoFocus,
  customMask,
  trigger,
  onFocus,
  onBlur,
  onClick,
  onChange,
}) => {
  if (customMask) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <LabelInput
            hidden={type === 'hidden'}
            className={className || ''}
            hasicon={!!icon}
            isdisabled={disabled}
            invalid={!!error}
            style={style}
            height={height}
          >
            {icon ? <Icon icon={icon} className="fieldIcon" /> : ''}
            <input
              {...field}
              maxLength={maxLenght}
              placeholder={placeholder}
              autoFocus={autoFocus}
              className="input"
              onChange={(e) => {
                field.onChange(e);
                trigger(name);
                onChange && onChange(e.target.value);
              }}
              onFocus={onFocus && onFocus}
              onBlur={() => {
                field.onBlur();
                trigger(name);
                onBlur && onBlur();
              }}
              value={stringToPhone(field.value)}
              onClick={onClick && onClick}
            />
            <span className="label">{label}</span>
            <div className="errorInput errorCustomInput">
              {error ? error.message : ''}
            </div>
          </LabelInput>
        )}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LabelInput
          hidden={type === 'hidden'}
          className={className || ''}
          hasicon={!!icon}
          isdisabled={disabled}
          invalid={!!error}
          style={style}
          height={height}
        >
          {icon ? <Icon icon={icon} className="fieldIcon" /> : ''}
          <input
            {...field}
            maxLength={maxLenght}
            placeholder={placeholder}
            autoFocus={autoFocus}
            className="input"
            onChange={(e) => {
              field.onChange(e);
              trigger(name);
              onChange && onChange(e.target.value);
            }}
            onFocus={onFocus && onFocus}
            onBlur={() => {
              field.onBlur();
              trigger(name);
              onBlur && onBlur();
            }}
            onClick={onClick && onClick}
          />
          <span className="label">{label}</span>
          <div className="errorInput errorCustomInput">
            {error ? error.message : ''}
          </div>
        </LabelInput>
      )}
    />
  );
};

export default FieldControled;
